import { EntityType } from '@frontend/common';
import { AnswerClient } from '@frontend/question/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useAnswer:request': CustomEvent<string>;
    }
}

const REQUEST_QUESTION_EVENT = 'useAnswer:request';
const STORAGE_KEY = 'ANSW_REQ';

export function answerRequest(answerId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_QUESTION_EVENT, { detail: answerId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function AnswerResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_QUESTION_EVENT, EntityType.ANSWER, (ids) => AnswerClient.resolveAnswers(ids), props.dispatch);
    return <></>;
}
